function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.979,66.924c-1.652,0-2.995,1.343-2.995,2.997c0,1.655,1.343,2.998,2.995,2.998h37.959c1.653,0,2.995-1.343,2.995-2.998 c0-1.654-1.342-2.997-2.995-2.997H16.979z M16.979,50.943c-1.652,0-2.995,1.342-2.995,2.997c0,1.654,1.343,2.997,2.995,2.997h37.959 c1.653,0,2.995-1.343,2.995-2.997c0-1.655-1.342-2.997-2.995-2.997H16.979z M16.979,34.962c-1.652,0-2.995,1.341-2.995,2.995 s1.343,2.997,2.995,2.997h37.959c1.653,0,2.995-1.343,2.995-2.997s-1.342-2.995-2.995-2.995H16.979z M5.994,22.32 c1.771,1.042,3.826,1.655,5.991,1.655h53.938v59.932H9.989c-2.268,0-3.995-1.729-3.995-3.995V22.32z M11.985,5.994h46.605 c-1.047,1.771-1.656,3.825-1.656,5.994s0.609,4.223,1.656,5.992H11.985c-2.882,0-5.991-3.108-5.991-5.992S9.104,5.994,11.985,5.994z M11.985,0C5.462,0,0,5.464,0,11.988v67.924c0,5.48,4.507,9.987,9.989,9.987h58.935c1.565,0,2.995-1.428,2.995-2.997V20.978 c-0.013-1.761-1.285-3.012-2.995-2.998c-2.884,0-5.995-3.108-5.995-5.992s3.111-5.994,5.995-5.994 c1.582,0.024,2.995-1.411,2.995-2.996c0-1.584-1.413-3.02-2.995-2.997H11.985z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.921 89.899",
    enableBackground: "new 0 0 71.921 89.899",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/atlas.ab4f622a.svg";
export { SvgComponent as ReactComponent };